import { BACKEND_URL } from '../utils/settings'

const BikeImageWatermark = ({ lightness, className, pdf, baseModelId }) => {
  const isCargo = baseModelId.includes('cargo')
  const logoSrcBase = `${BACKEND_URL}/images/logos/`
  const pdfLogoSrc = `${logoSrcBase}logo.png`
  const lightLogoSrc = `${logoSrcBase}velorbis${
    lightness < 0.38 ? '--white' : ''
  }.png`
  const waterMarkClassName = `${!pdf && isCargo ? 'canvas-cargo ' : ''}velorbis-customizer-bike-canvas__watermark${
    className ? ` ${className}` : ''
  }`
  if (pdf) {
    return (
      <img src={pdfLogoSrc} className={waterMarkClassName} alt="watermark" />
    )
  }
  return (
    <img src={lightLogoSrc} className={waterMarkClassName} alt="watermark" />
  )
}

export default BikeImageWatermark
